import React, { useState, useEffect } from "react";
import AthleteLayout from "../common/AthleteLayout";
import { useAthleteAuthContext } from "../login/useAthleteAuthContext";
import { Link } from "react-router-dom";
import API_URL from "../../api/API";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import { AthleteHeader } from "../common/AthleteHeader";
import { useNavigate } from "react-router-dom";
import bgImg from "../../images/runRocket.jpeg";
import bgCenterImg from "../../images/runRocketIcon.png";

export const AthleteRunrocketTestStep1 = () => {
  const { athlete } = useAthleteAuthContext();
  const navigate = useNavigate();

  const [maxSpeed1, setMaxSpeed1] = useState(""); // State for max speed
  const [error, setError] = useState(""); // State for error messages

  const [showInfo, setShowInfo] = useState(false);

  useEffect(() => {
    // Restore data from sessionStorage
    const maxSpeed1_ = sessionStorage.getItem("maxSpeed1");

    // console.log("Found Session MaxSpeed1: " + maxSpeed1_);

    if (maxSpeed1_) setMaxSpeed1(maxSpeed1_);
  }, []);

  const handleSaveMaxSpeed = () => {
    if (!maxSpeed1 || isNaN(maxSpeed1) || Number(maxSpeed1) <= 0) {
      setError("Please enter a valid positive number.");
      return;
    }
    // Save to session storage and clear errors
    sessionStorage.setItem("maxSpeed1", maxSpeed1);
    setError(""); // Clear any existing errors
    alert("Rest for 6 minutes and then continue!");
    navigate("/athlete/tools/runrocket/test/step2");
  };

  return (
    <AthleteLayout>
      <div className="relative h-full overflow-y-auto bg-white">
        {/* background image */}
        <div className="absolute inset-0">
          <img src={bgImg} alt="bgImg" className="object-cover w-full h-full" />
          <div className="w-full h-full absolute inset-0 bg-white/80"></div>
        </div>
        {/* tab header */}
        <div className="relative w-full max-w-2xl mx-auto px-5">
          <div className="bg-black rounded-2xl flex justify-between gap-8 px-4 py-3 mt-3 mb-7">
            <span className="text-white text-sm xs:text-base cursor-pointer">Test</span>
            <span className="text-white/40 text-sm xs:text-base hover:text-white cursor-pointer transition">
              Train
            </span>
            <span className="text-white/40 text-sm xs:text-base hover:text-white cursor-pointer transition">
              Performance
            </span>
          </div>
        </div>

        <div className="relative w-full max-w-2xl mx-auto px-5">
          <div className="relative flex justify-between items-center gap-5 mb-14">
            <div
              onClick={() => navigate(-1)}
              className="flex items-center gap-2 cursor-pointer py-1 px-2 rounded-md hover:bg-smock transition"
            >
              <ArrowL />
              <span className="text-black text-sm font-medium">Back</span>
            </div>

            <span className="text-black text-xl xs:text-2xl font-bold leading-[91%] capitalize">
            AST Speed Profile™
            </span>

            {/* for centering title */}
            <div className="opacity-0 pointer-events-none">
              <div className="flex items-center gap-2 cursor-pointer hover:opacity-80 transition">
                <ArrowL />
                <span className="text-black text-sm font-medium">Back</span>
              </div>
            </div>
          </div>
          <div className="mx-auto w-fit block space-y-8 mb-8">
            <div style={{ width: 174, height: 174 }}>
              <CircularProgressbarWithChildren
                strokeWidth={5}
                value={25}
                styles={buildStyles({
                  textColor: "#000", // Text color
                  pathColor: "#c19e42", // Progress path color
                  trailColor: "#000", // Background path color
                })}
              >
                <img
                  src={bgCenterImg}
                  alt="bgCenterImg"
                  className="w-24 h-24 object-contain mb-2"
                />
              </CircularProgressbarWithChildren>
            </div>
            <div className="text-center">
              <p className="text-black text-xl xs:text-2xl font-bold uppercase">
                Step 1
              </p>
            </div>
          </div>
          <div className="flex flex-col gap-2 mb-10">
            <div className="relative mb-3">
              <div className="bg-black rounded-2xl relative px-3 py-4 flex justify-center items-center divide-x-2 divide-darkYellow">
                <div className="flex-1 space-y-2 px-1 text-center">
                  <p className="block text-white text-sm xs:text-base font-medium">
                    REPS
                  </p>
                  <span className="block text-white text-sm xs:text-base font-light">
                    1
                  </span>
                </div>
                <div className="flex-1 space-y-2 px-1 text-center">
                  <p className="block text-white text-sm xs:text-base font-medium">
                    Distance
                  </p>
                  <span className="block text-white text-sm xs:text-base font-light">
                    25m
                  </span>
                </div>
                <div className="flex-1 space-y-2 px-1 text-center">
                  <p className="block text-white text-sm xs:text-base font-medium">
                    LOAD
                  </p>
                  <span className="block text-white text-sm xs:text-base font-light">
                    0
                  </span>
                </div>
              </div>
              {/* i icon */}
              <div className="absolute top-2 right-2">
                <button
                  type="button"
                  onClick={() => setShowInfo(true)}
                  className="group w-6 h-6 rounded-full border border-darkYellow bg-black flex items-center justify-center transition-all duration-200 hover:bg-darkYellow"
                >
                  <span className="text-darkYellow group-hover:text-black text-xs font-bold leading-none">
                    i
                  </span>
                </button>
              </div>
            </div>
            <div className="relative w-full space-y-5">
              <input
                type="text"
                placeholder="Enter max speed"
                className="bg-smock/70 block w-full p-3 border border-black/25 rounded-xl text-center text-black text-base"
                value={maxSpeed1}
                onChange={(e) => setMaxSpeed1(e.target.value)}
              />
              {/* <button className="absolute right-5 top-1/2 -translate-y-1/2 bg-[#00901E] text-white p-2 rounded-full">
                <Add />
              </button> */}
              <button
                onClick={handleSaveMaxSpeed}
                className="w-full block text-center p-3 text-white text-base leading-none bg-darkYellow hover:bg-yellow-600 rounded-xl capitalize transition-all duration-300"
              >
                Add
              </button>
            </div>
            {error && (
              <p className="text-red-500 text-sm mt-2 text-center">{error}</p>
            )}
          </div>
        </div>
        {/* </div> */}
      </div>


      {showInfo && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-4">
    <div className="bg-white rounded-2xl shadow-xl max-w-md w-full p-6 relative">
      <button
        onClick={() => setShowInfo(false)}
        className="absolute top-3 right-4 text-2xl text-gray-500 hover:text-black"
      >
        ×
      </button>

      <h3 className="text-xl font-bold text-darkYellow mb-4">
        Step 1 — Level 0: Baseline Sprint
      </h3>

      <p className="text-gray-700 leading-7">
        Set the <strong>Run Rocket</strong> to <strong>Level 0</strong>.
        Complete the sprint at <strong>maximum effort</strong> through the full
        <strong> 25m</strong> distance. Record your maximum speed and enter it
        into the field below before continuing.
      </p>

      <button
        onClick={() => setShowInfo(false)}
        className="mt-6 w-full bg-darkYellow text-white py-3 rounded-xl hover:bg-yellow-600 transition"
      >
        Got it
      </button>
    </div>
  </div>
)}
    </AthleteLayout>
  );
};

const ArrowL = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M7 13L1 7L7 1"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const Add = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="22"
      viewBox="0 0 21 22"
      fill="none"
    >
      <path
        d="M10.5 1V21M0.5 11C8.31049 11 12.6895 11 20.5 11"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
